module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CloudChainStoreInfo");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CloudChainStoreInfo!./src/pages/Shop/Member/Personal/CloudChain/CloudChainStoreInfo/index.js
// module id = 2044
// module chunks = 367